'use client';
import { useState } from 'react';
import { ApertureLogo } from '../aperture-logo';
import { WAITLIST_URL } from './config';

/**
 * Nav terminal · sticky · light theme dentro del lp-v5.
 * Mobile menu se monta al togglear.
 */
export function NavV5() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <nav className="nav">
        <div className="inner">
          <a className="brandmark" href="/" aria-label="ARKU inicio">
            <ApertureLogo size={25} />
            <span className="wm">ARKU</span>
          </a>
          <div className="nav-links">
            <a href="#sistema">Sistema</a>
            <a href="#red">La red</a>
            <a href="#confianza">Confianza</a>
            <a href="#consola">Inteligencia</a>
          </div>
          <div className="nav-status">
            <span className="pulse" /> Mercado activo · Perú
          </div>
          <div className="nav-cta">
            <a className="btn btn-primary" href={WAITLIST_URL}>
              Únete a la red
            </a>
          </div>
          <button
            type="button"
            className="nav-toggle"
            aria-label="Menú"
            aria-expanded={open}
            onClick={() => setOpen(o => !o)}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              {open ? (
                <path d="M6 6l12 12M6 18L18 6" />
              ) : (
                <path d="M3 6h18M3 12h18M3 18h18" />
              )}
            </svg>
          </button>
        </div>
      </nav>
      {open && (
        <div className="mobile-menu open" onClick={() => setOpen(false)}>
          <a href="#sistema">Sistema</a>
          <a href="#red">La red</a>
          <a href="#confianza">Confianza</a>
          <a href="#consola">Inteligencia</a>
          <a className="btn btn-primary btn-block" href={WAITLIST_URL}>
            Únete a la red
          </a>
        </div>
      )}
    </>
  );
}
